<template>
  <div>
    <div class="con-list f-clearfix">
      <div style="margin-bottom: 30px">
        <el-button
          v-if="sortType == 1"
          size="medium"
          type="primary"
          @click="orderBy(1)"
        >
          选课人数
          <i class="el-icon-bottom"></i>
        </el-button>
        <el-button
          v-if="sortType == 2"
          size="medium"
          type="primary"
          @click="orderBy(2)"
        >
          选课人数
          <i class="el-icon-top"></i>
        </el-button>
      </div>
      <div v-if="noData == true" class="no-data">
        <h2>暂无相关内容</h2>
      </div>
      <ul class="con-course f-clearfix">
        <li v-for="(item, index) in tableList" :key="index" :title="item.name">
          <div
            v-if="item.tagId != null"
            id="item-course-tags-b"
            :class="
              item.tagId == '1169810873999269889'
                ? 'tagA'
                : item.tagId == '1242344957122658306'
                ? 'tagB'
                : 'tagC'
            "
          ></div>
          <div
            v-if="item.tagId != null"
            id="item-course-tags"
            :class="
              item.tagId == '1169810873999269889'
                ? 'tagA'
                : item.tagId == '1242344957122658306'
                ? 'tagB'
                : 'tagC'
            "
          >
            <span :title="item.tagTitle">{{ item.tagTitle }}</span>
            <!-- <span v-else-if="item.tagTitle == '1242344957122658306'">{{
                      item.tagTitle
                    }}</span> -->
          </div>
          <a :href="item.ctUrl" target="_blank">
            <div class="item-img">
              <img v-img.lazy="item.ctImgUrl" :alt="item.name" />
            </div>
            <h3>{{ item.name }}</h3>
            <div class="item-teacher">
              <span class="item-school">{{ item.teacherName }}</span>
            </div>
            <div>
              <span class="item-school">{{
                item.collegeTitle || item.schoolName
              }}</span>
              <span class="item-edu"> {{ item.enrollCount }}人选课 </span>
            </div>
          </a>
        </li>
      </ul>
      <div class="m-pagination-wrapper">
        <el-pagination
          class="m-pagination"
          @current-change="coursePage"
          :page-size="pageList.pageSize"
          :hide-on-single-page="true"
          :current-page.sync="pageList.pageNo"
          :total="pageList.total"
          layout=" prev, pager, next"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      noData: false,
      tableList: [],
      sortType: 1,
      pageList: {
        pageNo: 1,
        pageSize: 24,
        total: 0,
      },
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    coursePage(val) {
      this.pageList.pageNo = val;
      this.getList();
    },
    //升序与降序
    orderBy(val) {
      if (val == 1) {
        this.sortType = 2;
      } else {
        this.sortType = 1;
      }
      this.getList();
    },
    getList() {
      this.noData = false;
      let par = {
        pageSize: this.pageList.pageSize,
        currentPage: this.pageList.pageNo,
        sortType: this.sortType,
      };
      this.$http
        .post("api/web/course/rank", par)
        .then((res) => {
          this.tableList = res.data.records;
          this.pageList.total = res.data.total;
          this.pageList.pageNo = res.data.current;
          if (res.data.records == "") {
            this.noData = true;
          }
        })
        .catch((msg) => {
          console.log(msg);
        });
    },
  },
};
</script>
<style lang="scss"></style>
